"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var _theme = _interopRequireDefault(require("../../../typography/theme"));
var _theme2 = _interopRequireDefault(require("./theme"));
var useStyles = (0, _core.makeStyles)({
  inputLabel: {
    fontFamily: _theme["default"].fonts.sans,
    fontWeight: _theme["default"].fontWeights.medium,
    fontSize: '0.8125rem',
    lineHeight: '1.125rem',
    margin: function margin(props) {
      return props.standalone ? '0' : '0rem 1rem';
    },
    overflow: 'hidden',
    whiteSpace: function whiteSpace(props) {
      return props.standalone ? 'normal' : 'nowrap';
    },
    wordBreak: function wordBreak(props) {
      return props.standalone ? 'break-word' : undefined;
    },
    textOverflow: function textOverflow(props) {
      return props.standalone ? undefined : 'ellipsis';
    },
    width: 'calc(100% - 2rem)',
    color: "".concat(_theme2["default"]["default"].labelColor),
    padding: function padding(props) {
      return props.standalone ? '0' : undefined;
    },
    paddingInlineEnd: function paddingInlineEnd(props) {
      return props.standalone ? '0' : undefined;
    },
    paddingInlineStart: function paddingInlineStart(props) {
      return props.standalone ? '0' : undefined;
    },
    '&&': {
      transform: function transform(props) {
        return props.standalone ? undefined : 'translate(0rem, 0.5rem) scale(1)';
      }
    },
    '&&.Mui-error': {
      color: _theme2["default"].error.color
    },
    '&&.Mui-disabled': {
      color: _theme2["default"].disabled.labelColor
    }
  },
  requiredAsterisk: {
    color: _theme2["default"]["default"].requiredColor,
    '&&.Mui-error': {
      color: _theme2["default"]["default"].requiredColor
    }
  },
  focusedInputLabel: {
    '&&:not(.Mui-error)': {
      color: _theme2["default"].focused.color
    }
  },
  inputWrapper: {
    '&&&&': {
      outline: "1px solid ".concat(_theme2["default"]["default"].borderColor),
      borderRadius: '4px',
      fontFamily: _theme["default"].fonts.sans,
      fontSize: '1rem',
      lineHeight: '1.5rem',
      height: function height(props) {
        return props.searchInput ? '2.25rem' : undefined;
      },
      color: _theme2["default"]["default"].color,
      WebkitTextFillColor: _theme2["default"]["default"].color,
      backgroundColor: function backgroundColor(props) {
        return props.readOnly ? _theme2["default"].readOnly.backgroundColor : _theme2["default"]["default"].backgroundColor;
      },
      '&&.MuiFilledInput-multiline': {
        padding: 0
      },
      '&&.Mui-error': {
        borderColor: _theme2["default"].error.borderColor
      },
      '&&.Mui-disabled': {
        backgroundColor: _theme2["default"].disabled.backgroundColor
      }
    }
  },
  inputWrapperUnderline: {
    '&&&:before': {
      borderBottom: 'none'
    },
    '&&:after': {
      content: '"\\00a0"',
      borderBottom: 'none',
      boxShadow: "inset 0px -2px 0px ".concat(_theme2["default"].focused.borderBottomColor)
    },
    '&&.Mui-error:after': {
      transform: 'scaleX(0)',
      borderBottom: 'none',
      boxShadow: "inset 0px -2px 0px ".concat(_theme2["default"].error.borderColor)
    },
    '&&.Mui-error.Mui-focused:after': {
      transform: 'scaleX(1)'
    }
  },
  htmlInput: {
    '&&&': {
      border: "none",
      borderRadius: '4px',
      color: "".concat(_theme2["default"]["default"].color),
      fontSize: '1rem',
      height: '1.5rem',
      padding: function padding(props) {
        return props.label ? '1.75rem 1rem 0.5rem' : '0.5rem 1rem';
      },
      width: '100%',
      '&&.MuiFilledInput-inputMultiline': {
        resize: function resize(props) {
          return props.autoresize ? 'none' : 'vertical';
        },
        overflow: 'auto !important',
        paddingTop: function paddingTop(props) {
          return props.label ? '0rem' : '.625rem';
        },
        marginTop: function marginTop(props) {
          return props.label ? '2rem' : '0rem';
        }
      },
      '&.MuiInputBase-inputAdornedStart': {
        paddingLeft: function paddingLeft(props) {
          return props.searchInput ? '0.5rem' : '0';
        }
      },
      '.Mui-error &&': {
        borderColor: _theme2["default"].error.borderColor
      },
      '&&&.Mui-disabled': {
        backgroundColor: _theme2["default"].disabled.backgroundColor,
        color: _theme2["default"].disabled.labelColor
      },
      '&&::placeholder': {
        display: 'block !important',
        opacity: '1 !important',
        WebkitTextFillColor: "".concat(_theme2["default"]["default"].placeholder, " !important")
      }
    }
  },
  adornedStart: {
    paddingLeft: '1rem'
  },
  adornedEnd: {
    paddingRight: '1rem'
  },
  helperText: {
    marginLeft: '1rem'
  }
});
var _default = useStyles;
exports["default"] = _default;